import { createSelector } from '@ngrx/store';
import * as fromPaymentsAndInvoicesReducer from '../reducers';
import * as fromPaymentDay from '../reducers/payment-day.reducer';

export const selectPaymentDay = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentDayEntitiesState,
  fromPaymentDay.selectPaymentDay
);
export const selectPaymentDayIsLoaded = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentDayEntitiesState,
  fromPaymentDay.selectPaymentDayLoaded
);
export const selectPaymentDayError = createSelector(
  fromPaymentsAndInvoicesReducer.selectPaymentDayEntitiesState,
  fromPaymentDay.selectPaymentDayError
);
